module.exports = __webpack_public_path__ + "img/rku10-2.b8f28246.png";